import React from "react";
import { usePathModeStore } from "../Store/PotreeStore";
import PotreeViewer3 from "./PotreeViewer3";
import PotreeViewer2 from "./PotreeViewer2";

export default function PotreeViewer() {
  const { SelectionGenerateMode } = usePathModeStore();
  return (
    <div>
      {SelectionGenerateMode === "auto" ? <PotreeViewer3 /> : <PotreeViewer2 />}
    </div>
  );
}
